import * as React from "react"
import { CheckCircle, XCircle, AlertTriangle, Info, X } from "lucide-react"
import { cn } from "@/lib/utils"

interface ToastIconProps {
  variant?: "default" | "success" | "error" | "warning" | "info" | "destructive"
  className?: string
}

export function ToastIcon({ variant = "default", className }: ToastIconProps) {
  const iconMap = {
    default: Info,
    success: CheckCircle,
    error: XCircle,
    warning: AlertTriangle,
    info: Info,
    destructive: XCircle,
  }

  const colorMap = {
    default: "text-gray-500 dark:text-gray-400",
    success: "text-green-600 dark:text-green-400",
    error: "text-red-600 dark:text-red-400",
    warning: "text-yellow-600 dark:text-yellow-400",
    info: "text-blue-600 dark:text-blue-400",
    destructive: "text-red-600 dark:text-red-400",
  }

  const Icon = iconMap[variant]

  return (
    <div className={cn(
      "flex-shrink-0 w-5 h-5",
      colorMap[variant],
      className
    )}>
      <Icon className="w-full h-full" />
    </div>
  )
}

export { ToastIcon as default }